export default __webpack_public_path__ + "static/media/Father.39453f4b.png";